import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Globals } from '../../shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserData } from '../../shared/models/DTO/UserData';
import { GenericVm } from '../../shared/models/system/generic-vm';
import { Message } from '../../shared/models/system/message';
import { MessageEnum } from '../../shared/models/system/message.enum';
import { CRN } from '../../shared/models/BasicData/CRN';
import { StudentCRN } from '../../shared/models/BasicData/StudentCRN';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  constructor(private httpRes: HttpRequestService, private globals: Globals, private translate: TranslateService) { }

  getCourses(page, pageSize) {
    return this.httpRes.GetRequest('course/courses/' + page + '/' + pageSize);
   
  }

  get() {
    return this.httpRes.GetRequest('course/courses/').toPromise();
   
  }

  getPrograms() {
    return this.httpRes.GetRequest('program/all/');
   
  }

  getColleges() {
    return this.httpRes.GetRequest('faculty/all/');
   
  }

  searchCourses(keyWord,program,college, page,pageSize) {
    var url = 'course/Search/' + encodeURIComponent(keyWord);
    return this.httpRes.GetRequest(url+'/' + program +'/' + college + '/'+page+"/" + pageSize);

  }
}
